import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { EmptyMeetingHistory } from './empty_meeting_history';
const sectionHeaderCss = "sho2v2p";
const SectionHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionHeaderCss, props.className)} />;
});
const containerCss = "c1iqpf0g";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const RenderNoMeetingHistory = () => <>
    <Container>
      <SectionHeader>
        <BodyText size="medium" color="muted" weight="bold">{I18n.t('publisher.contacts.profile.meetings')}</BodyText>
      </SectionHeader>
    </Container>
    <EmptyMeetingHistory />
  </>;
export const MeetingHistorySection = () => <RenderNoMeetingHistory />;

require("./meeting_history_section.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_history_section.js");